export const createAdobeData = (adobeEvent:string, adobePageName:string, adobeSearchType:string, adobeQuery:string, adobeFeedback:string, adobeComment:string) => {
    const adobeData = {
      event: adobeEvent,
      "_emiratesnbd": {
        pageinfo: {
          pagename: adobePageName,
        },
        chatbotinfo: {
          chatbot_searchtype: adobeSearchType,
          chatbot_query: adobeQuery,
          chatbot_feedback: adobeFeedback,
          chatbot_comment: adobeComment,
        },
      },
    };
    // Push the data to Adobe's data layer, if available
    (window as any)?.adobeDataLayer?.push(adobeData);
   
  }
  
  